import React from "react";
import { Link } from "react-router-dom";

const Button = ({
    className,
    children,
    isPrimary,
    isSecondary,
    as = "button",
    to,
    href,
    ...props
}) => {
    const baseClasses = `relative inline-flex justify-center items-center h-10 px-3.5 rounded-lg text-title-5 cursor-pointer transition-all ${
        isPrimary ? "bg-white text-black hover:bg-white/90" : ""
    } ${
        isSecondary
            ? "shadow-[0.0625rem_0.0625rem_0.0625rem_0_rgba(255,255,255,0.10)_inset] text-white after:absolute after:inset-0 after:border after:border-line after:rounded-lg after:pointer-events-none after:transition-colors hover:after:border-white"
            : ""
    } ${className || ""}`;

    if (as === "link" && to) {
        return (
            <Link className={baseClasses} to={to} {...props}>
                {children}
            </Link>
        );
    }

    if (as === "a" && href) {
        return (
            <a className={baseClasses} href={href} {...props}>
                {children}
            </a>
        );
    }

    return (
        <button className={baseClasses} {...props}>
            {children}
        </button>
    );
};

export default Button;
